module.exports = __webpack_public_path__ + "static/img/ryzylx.5415f9ab.png";